var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex",
      class: { "flex-column": _vm.isStacked, "align-center": _vm.isStacked },
    },
    [
      _c(
        "v-tooltip",
        {
          attrs: { right: "", "open-delay": "500" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            outlined: "",
                            fab: "",
                            small: "",
                            color: _vm.color,
                            disabled: _vm.isLoading || _vm.isPendingShare,
                            loading: _vm.isSharing,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("share-character")
                            },
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [_c("v-icon", [_vm._v("share")])],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v(_vm._s(_vm.day6Resource.shareLinkHint))])]
      ),
      _c(
        "div",
        {
          staticClass: "d-flex justify-center align-center",
          class: { "mt-1": _vm.isStacked, "ml-1": !_vm.isStacked },
          attrs: { title: _vm.day6Resource.shareLevelHint(_vm.shareLevel) },
        },
        [
          _vm.isQueryingShareLevel || _vm.isPendingShare || _vm.isSharing
            ? _c("v-icon", { attrs: { color: "grey lighten-1", small: "" } }, [
                _vm._v("pending"),
              ])
            : _c("v-icon", { attrs: { color: "grey lighten-1", small: "" } }, [
                _vm._v(_vm._s(_vm.shareLevelIcon)),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }